import React, { ReactElement } from 'react';
import ReactTooltip from 'react-tooltip';
import { useTheme } from '@emotion/react';
import { useIntl } from 'react-intl';

import { SVGIcon, SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { computeText } from '@/locales/utils';
import {
    IconContainer,
    LabelContainer,
    TooltipContent,
    TooltipTitle,
    TooltipDescription,
    TooltipExample,
} from './LabelWithTooltip.style';

export type LabelWithTooltipProps = {
    text: string;
    helperText: string;
    id?: string;
    tooltipTitle?: string;
    tooltipExample?: string;
    className?: string;
};

const LabelWithTooltip = ({
    text,
    helperText,
    id = 'info',
    tooltipTitle,
    tooltipExample,
    className,
    ...otherProps
}: LabelWithTooltipProps): ReactElement => {
    const theme = useTheme();
    const intl = useIntl();

    return (
        <LabelContainer className={className} {...otherProps}>
            {text}{' '}
            <IconContainer data-tip data-for={id}>
                <SVGIcon icon={SVGIcons.INFO} color={theme.color.black300} size={12} />
            </IconContainer>
            <ReactTooltip id={id} place="top" effect="solid">
                <TooltipContent>
                    {tooltipTitle && <TooltipTitle>{tooltipTitle}</TooltipTitle>}
                    <TooltipDescription>{helperText}</TooltipDescription>
                    {tooltipExample && (
                        <TooltipExample>
                            <strong>{computeText(intl, 'tooltip.example.label')}</strong>
                            <br />
                            {tooltipExample}
                        </TooltipExample>
                    )}
                </TooltipContent>
            </ReactTooltip>
        </LabelContainer>
    );
};

export default LabelWithTooltip;
